export interface LatestOperationGate {
  begin: () => number
  isCurrent: (token: number) => boolean
  current: () => number
}

export const createLatestOperationGate = (): LatestOperationGate => {
  let currentToken = 0

  return {
    begin() {
      currentToken += 1
      return currentToken
    },
    isCurrent(token: number) {
      return token === currentToken
    },
    current() {
      return currentToken
    }
  }
}
